import { map, isEmpty } from 'lodash';
import { api } from 'src/common/utils';

import { AccountApiResponseType } from '../types';

import { FilterType } from './types';

type ApiPayloadType = {
  currentPage: number;
  search: string;
  filters: FilterType;
  basicInfo?: boolean;
};

const ACCOUNTS_ROOT_PATH = 'account_admin';

export const fetchAccounts = async (
  _: string,
  payload: ApiPayloadType
): Promise<AccountApiResponseType> => {
  const { currentPage, search, filters, basicInfo } = payload;
  let queryParams = `?page=${currentPage}`;
  if (search) {
    queryParams += `&search=${encodeURIComponent(search)}`;
  }
  if (basicInfo) {
    queryParams += `&basic_info=true`;
  }
  if (!isEmpty(filters)) {
    map(filters, (values, key) => {
      if (values.type === 'select') {
        const selectedOptions = map(values.options, 'value');
        queryParams += `&${key}=${selectedOptions.join(',')}`;
      }
      if (values.type === 'boolean') {
        // boolean always has one
        const selectedOption = values.options[0];
        queryParams += `&${key}=${selectedOption.value}`;
      }
    });
  }
  const response = await api.get(`/${ACCOUNTS_ROOT_PATH}${queryParams}`);
  return response.data as AccountApiResponseType;
};
